import * as React       from "react";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {Load2}          from "@Common/react/load2";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import "./orderDetails.scss";

export const OrderDetails = ({orderId, orderName, domRef, isListingsEligible, changeListingModal, listing, companyPrefs, item, userLevel}) => cs(
    consumeContext("apis"),
    ["order", (_, next) => UseState({
        initValue: orderName.value,
        next,
      })],
    ["allowOfficeEdit", ({apis}, next) => Load2({
        fetch: async () => !orderId ? null : parseInt( await apis.next.OrderManager.getOrderColumn(orderId, "allowEditOffice") || 0 ),
        next,
    })],
    ["allowOfficePlace", ({apis}, next) => Load2({
        fetch: async () => !orderId ? null : parseInt( await apis.next.OrderManager.getOrderColumn(orderId, "allowPlaceOffice") || 0 ),
        next,
    })],
    ["allowUserEdit", ({apis}, next) => Load2({
        fetch: async () => !orderId ? null : parseInt( await apis.next.OrderManager.getOrderColumn(orderId, "allowEditUser") || 0 ),
        next,
    })],
    ["allowUserPlace", ({apis}, next) => Load2({
        fetch: async () => !orderId ? null : parseInt( await apis.next.OrderManager.getOrderColumn(orderId, "allowPlaceUser") || 0 ),
        next,
    })],
    ({order, allowOfficeEdit, allowOfficePlace, allowUserEdit, allowUserPlace}) => <>
        <div className="order-details-7d8" ref={domRef}>
            <h3 className="order-details-title" xd-qa-type="label" xd-qa-name="Order Details Title">Order Information</h3>
            <div className="order-details-content" >
                <div className="label-and-input-instance">Order ID</div>
                <input name="order_id" value={orderId} readOnly={true} xd-qa-type="text_field" xd-qa-name="Order Id" />
                <div className="label-and-input-instance">Order Name</div>
                <input type="text" name="order_name" onChange={(e) => order.onChange(e.target.value)} value={order.value} xd-qa-type="text_field" xd-qa-name="Order Name" />
                {isListingsEligible &&
                <>
                    <div className="label-and-input-instance">Listing</div><div className="listing-build3">
                        <input type="text" name="listing_name" value={listing} readOnly={listing == "No listing Selected" ? true : false} xd-qa-type="text_field" xd-qa-name="Listing Name" />
                        <button onClick={changeListingModal}>{listing == "No listing Selected" ? "Select Listing" : "Change Listing"}</button>
                    </div>
                </>
                }
                {userLevel <= 4 && <>
                    <div className="label-and-input-instance">Order Permissions</div>
                    {userLevel <= 3 && <>
                        <div className="check">
                            <input
                                name="allowEditOffice"
                                type="checkbox"
                                value={allowOfficeEdit.value}
                                hidden
                                xd-qa-type="checkbox"
                                xd-qa-name="Allow Office to edit this order"
                            />
                            <SliderCheckbox
                                value={allowOfficeEdit.value}
                                dark={true}
                                onChange={() => allowOfficeEdit.onChange(allowOfficeEdit.value == 1 ? 0 : 1)}
                                xdQaType="checkbox"
                                xdQaName="Allow Office to edit this order"
                            />
                            <div className="label-order-permission">Allow Office to edit this order</div>
                        </div>
                        <div className="check">
                            <input
                                name="allowPlaceOffice"
                                type="checkbox"
                                value={allowOfficePlace.value}
                                hidden
                                xd-qa-type="checkbox"
                                xd-qa-name="Allow Office to place this order"
                            />
                            <SliderCheckbox
                                value={allowOfficePlace.value}
                                dark={true}
                                onChange={() => allowOfficePlace.onChange(allowOfficePlace.value == 1 ? 0 : 1)}
                                xdQaType="checkbox"
                                xdQaName="Allow Office to place this order"
                            />
                            <div className="label-order-permission">Allow Office to place this order</div>
                        </div>
                    </>}
                    <div className="check">
                        <input
                            name="allowEditUser"
                            type="checkbox"
                            value={allowUserEdit.value}
                            hidden
                            xd-qa-type="checkbox"
                            xd-qa-name="Allow User to edit this order"
                        />
                        <SliderCheckbox
                            value={allowUserEdit.value}
                            dark={true}
                            onChange={() => allowUserEdit.onChange(allowUserEdit.value == 1 ? 0 : 1)}
                            xdQaType="checkbox"
                            xdQaName="Allow User to edit this order"
                        />
                        <div className="label-order-permission">Allow User to edit this order</div>
                    </div>
                    <div className="check">
                        <input
                            name="allowPlaceUser"
                            type="checkbox"
                            value={allowUserPlace.value}
                            hidden
                            xd-qa-type="checkbox"
                            xd-qa-name="Allow User to place this order"
                        />
                        <SliderCheckbox
                            value={allowUserPlace.value}
                            dark={true}
                            onChange={() => allowUserPlace.onChange(allowUserPlace.value == 1 ? 0 : 1)}
                            xdQaType="checkbox"
                            xdQaName="Allow User to place this order"
                        />
                        <div className="label-order-permission">Allow User to place this order</div>
                    </div>
                </>}
            </div>
        </div>
    </>
);